import { isEqual, keys, pick } from 'lodash'

import { Policyholder } from '../../../domain'

export const hasChanges = (
  original: Policyholder | undefined,
  update: Partial<Policyholder>,
): boolean => !isEqual(update, pick(original, keys(update)))
